import AuthNavbar from 'components/Navbars/AuthNavbar.jsx';
import { OrdenExpressGetRoutes } from 'orden_express/frameWork/frameWork';
import PerfectScrollbar from 'perfect-scrollbar';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { routesAuth } from 'routes';

var ps;

class Pages extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: 'black',
      activeColor: 'info',
    }
  }

  componentDidMount() {
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(this.refs.fullPages);
    }
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf('Win') > -1) {
      ps.destroy();
    }
  }

  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === '/auth') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  handleActiveClick = (color) => {
    this.setState({ activeColor: color });
  }
  handleBgClick = (color) => {
    this.setState({ backgroundColor: color });
  }

  render() {
    return (
      <div className='wrapper wrapper-full-page' ref='fullPages'>
        <AuthNavbar />
        <div className='full-page section-image'>
          <Switch>
            {OrdenExpressGetRoutes(routesAuth, '/auth')}
          </Switch>
        </div>
        {/*
        <FixedPlugin
          bgColor={this.state.backgroundColor}
          activeColor={this.state.activeColor}
          handleActiveClick={this.handleActiveClick}
          handleBgClick={this.handleBgClick}
        />
        */}
      </div>
    );
  }
}
export default Pages;